import { render } from "./ReRegris.vue?vue&type=template&id=470ecfc5&scoped=true"
import script from "./ReRegris.vue?vue&type=script&lang=js"
export * from "./ReRegris.vue?vue&type=script&lang=js"

import "./ReRegris.vue?vue&type=style&index=0&id=470ecfc5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ecfc5"]])

export default __exports__